import { Badge } from "react-bootstrap";
import circle from "../../../assets/img/m1.png/clusterIcon.png";

/**
 * Displays a cluster marker with the true count of all items in the cluster
 * (sum of each group's count, not the number of markers).
 */
export function ClusterMarker({ count, isSelected, onClick }) {
  return (
    <div style={{ position: "relative", transform: "translateY(50%)" }}>
      <img src={circle} width={"24px"} alt="Cluster" />
      <div
        style={{
          position: "absolute",
          top: "100%",
          left: "50%",
          transform: "translateX(-50%)",
          marginTop: 4,
          pointerEvents: "none",
        }}
      >
        <Badge pill bg="danger">
          {count}
        </Badge>
      </div>
    </div>
  );
}
